import React from 'react';
import { Button, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import LanguageTable from '../../AppGrid/LanguageTable';
import strings from '../../Globalization/index';
import { useBreadcrumbs } from '../../contexts/Breadcrumbs';
import util from '../../util';
import { useUniqueEffect } from "../../hooks";

const preferredLang = util?.localData?.loginData?.tags?.PreferredLang ?? 'en';
const BackButton = () => {
	return (<Button variant='contained' startIcon={<ArrowBackIcon />} component={Link} to={`/languagemapperlist`}>{strings.Back}</Button>)
}
const LanguageList = () => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	useUniqueEffect(() => {
		setBreadcrumbs({
			docTitle: strings.Language, breadcrumbs: [{ text: strings.Language }],
			actions: [{ component: BackButton }]
		});
	}, [breadcrumbs, preferredLang]);
	return (
		<Grid container>
			<Grid size={12}>
				<LanguageTable />
			</Grid>
		</Grid>
	);
};

export default LanguageList